module.exports = __webpack_public_path__ + "img/chantal-horeis-untitled.c5ae29c.jpg";